import type { SortOption } from "../../types";

export interface ProjectMetadataRef {
  uid: string;
  modelName: string;
}

export interface LibraryDetailRef {
  id: string;
}

export const fileQueryKeys = {
  finalFiles: (uid: string | null | undefined, sort: SortOption = "lastViewed") =>
    ["finalFiles", uid, sort] as const,
  finalFilesPrefix: (uid: string | null | undefined) =>
    ["finalFiles", uid] as const,
  sampleFinalFiles: (uid: string | null | undefined) =>
    ["sampleFinalFiles", uid] as const,
  rawFiles: (uid: string | null | undefined) => ["rawFiles", uid] as const,
  convertedFiles: (uid: string | null | undefined) =>
    ["convertedFiles", uid] as const,
  trashFiles: (uid: string | null | undefined) =>
    ["trashFiles", uid] as const,
  libraryItems: (uid: string | null | undefined) =>
    ["libraryItems", uid] as const,
  libraryDetail: (
    uid: string | null | undefined,
    objectRef: string | LibraryDetailRef | null | undefined,
  ) =>
    [
      "libraryDetail",
      uid,
      typeof objectRef === "string" ? objectRef : objectRef?.id,
    ] as const,
  storageUsage: (uid: string | null | undefined) =>
    ["storageUsage", uid] as const,
  recentFiles: (uid: string | null | undefined, sort: SortOption = "lastViewed") =>
    ["recentFiles", uid, sort] as const,
  projectMetadata: (
    uid: string | null | undefined,
    projectRef: string | ProjectMetadataRef | null | undefined,
  ) =>
    [
      "projectMetadata",
      uid,
      typeof projectRef === "string" ? projectRef : projectRef?.modelName,
    ] as const,
} as const;

export type FileQueryKeyFactory = typeof fileQueryKeys;
